
import axios from 'axios';
import { getServerError } from '../error/error-service';
import { schemaList } from './document-schema-service.data';
import { IApiDocumentSchema } from './document-schema-service.types';

const DocApiBaseUrl = `/doc-api`;


export const getList = (documentCodes: string[] | undefined) => {
    return Promise.resolve(schemaList);
    return axios.get<IApiDocumentSchema[]>(`${DocApiBaseUrl}/document-schema`, { params: { documentCodes } })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}

export const getSchemaByDocumentCode = (documentCode: string) => {
    return Promise.resolve(schemaList.find(s => s.documentCode === documentCode));
    return axios.get<IApiDocumentSchema>(`${DocApiBaseUrl}/document-schema/${documentCode}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}

